import apiEndPoints from '../../apiconstants';
import { api, handleErrorResponse, responseArgs } from '../api';
import { WorkflowDefinition } from '../../../../../../src/types/workflow';

export interface WorkflowResponse {
  data: WorkflowDefinition[];
  message?: string;
}

export interface SingleWorkflowResponse {
  data: WorkflowDefinition;
  message?: string;
}

export const workflowApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getWorkflows: builder.query<WorkflowResponse, void>({
      query: () => apiEndPoints.getWorkflows,
      transformResponse: (response: responseArgs) => response,
      transformErrorResponse: handleErrorResponse,
      providesTags: ['Workflow'],
    }),
    getWorkflowById: builder.query<SingleWorkflowResponse, string>({
      query: (id) => `${apiEndPoints.getWorkflowById}/${id}`,
      transformResponse: (response: responseArgs) => response,
      transformErrorResponse: handleErrorResponse,
      providesTags: (result, error, id) => [{ type: 'Workflow', id }],
    }),
    createWorkflow: builder.mutation<SingleWorkflowResponse, Partial<WorkflowDefinition>>({
      query: (workflow) => ({
        url: apiEndPoints.createWorkflow,
        method: 'POST',
        body: workflow,
      }),
      transformResponse: (response: responseArgs) => response,
      transformErrorResponse: handleErrorResponse,
      invalidatesTags: ['Workflow'],
    }),
    updateWorkflow: builder.mutation<SingleWorkflowResponse, { id: string; workflow: Partial<WorkflowDefinition> }>({
      query: ({ id, workflow }) => ({
        url: `${apiEndPoints.updateWorkflow}/${id}`,
        method: 'PUT',
        body: workflow,
      }),
      transformResponse: (response: responseArgs) => response,
      transformErrorResponse: handleErrorResponse,
      invalidatesTags: (result, error, { id }) => [{ type: 'Workflow', id }],
    }),
    deleteWorkflow: builder.mutation<{ message: string }, string>({
      query: (id) => ({
        url: `${apiEndPoints.deleteWorkflow}/${id}`,
        method: 'DELETE',
      }),
      transformResponse: (response: responseArgs) => response,
      transformErrorResponse: handleErrorResponse,
      invalidatesTags: ['Workflow'],
    }),
    runWorkflow: builder.mutation<{ executionId: string; status: string }, { id: string; payload?: any }>({
      query: ({ id, payload }) => ({
        url: `${apiEndPoints.runWorkflow}/${id}/run`,
        method: 'POST',
        body: payload || {},
      }),
      transformResponse: (response: responseArgs) => response.data,
      transformErrorResponse: handleErrorResponse,
    }),
  }),
});

export const {
  useGetWorkflowsQuery,
  useGetWorkflowByIdQuery,
  useCreateWorkflowMutation,
  useUpdateWorkflowMutation,
  useDeleteWorkflowMutation,
  useRunWorkflowMutation,
} = workflowApiSlice;

